module.exports = __webpack_public_path__ + "static/media/sama7.53fa9186.wav";